import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Globals } from 'src/app/Utils/globals';
import { SecurityFunctionalChecksService } from '../../security/services/security-functional-checks.service';
import { Archer } from '../../security/interfaces/security.interface';

@Component({
  selector: 'app-risk-acceptance',
  templateUrl: './risk-acceptance.component.html',
  styleUrls: ['./risk-acceptance.component.scss'],
})
export class RiskAcceptanceComponent {
  @Input() appUuid: string;
  @Input() evidenceId: string;
  @Input() securityArcher = false;
  @Output() emitRisk = new EventEmitter<string>();
  @Output() emitSearchCallState = new EventEmitter<string>();
  @Output() emitSubmitCallState = new EventEmitter<string>();

  searchCallState: string;
  submitCallState: string;
  archerStatus = '';
  archerId = '';
  archer: Archer;
  archerInfoUrl =
    'http://thenest-eur-hq.nestle.com/GL/GL_GLSC/grc/Pages/Archer.aspx';

  constructor(
    public globals: Globals,
    private readonly service: SecurityFunctionalChecksService,
  ) {}

  archerInputChanged() {
    if (!this.archerId) {
      this.archer = null;
      this.archerStatus = '';
    }
  }

  searchRisk() {
    this.searchCallState = this.globals.state_loading;
    this.emitSearchCallState.emit(this.searchCallState);
    this.archerStatus = '';
    this.service.validateRiskEvidence(this.archerId).subscribe({
      next: (data) => {
        if (data) {
          this.archerStatus = data.isValid ? 'valid' : 'invalid';
          this.archer = data;
          this.archerId = this.archer.riskManagementId;
        }
        this.searchCallState = this.globals.state_success;
        this.emitSearchCallState.emit(this.searchCallState);
      },
      error: (responseError) => {
        this.archerStatus = 'invalid';
        this.archer = {
          validationMessage: responseError.error.error,
          validationErrorCase: responseError.code,
          hasAcceptances: false,
          hasRemediationPlans: false,
          hasValidAcceptances: false,
          hasValidAcceptanceStatus: false,
          hasValidRemediationPlans: false,
          hasValidDueDate: false,
          isOpen: false,
          hasValidRemediationPlanStatus: false,
        };
        this.searchCallState = this.globals.state_success;
        this.emitSearchCallState.emit(this.searchCallState);
      },
    });
  }

  submitRisk() {
    if (this.securityArcher) {
      this.emitRisk.emit(this.archer.riskManagementId);
      return;
    }
    this.submitCallState = this.globals.state_loading;
    this.emitSubmitCallState.emit(this.submitCallState);
    this.service
      .uploadArcherEvidence(this.appUuid, this.evidenceId, this.archerId)
      .subscribe({
        next: () => {
          this.emitRisk.emit('archer');
          this.submitCallState = this.globals.state_success;
          this.emitSubmitCallState.emit(this.submitCallState);
        },
        error: () => {
          this.submitCallState = this.globals.state_success;
          this.emitSubmitCallState.emit(this.submitCallState);
        },
      });
  }

  // prettier-ignore
  getColorForText(archer: Archer): { //NOSONAR
    secondTitleColor: string;
    firstConditionColor: string;
    secondConditionColor: string;
    thirdConditionColor: string;
    fourthConditionColor: string;
    fifthConditionColor: string;
    sixthConditionColor: string;
    seventhConditionColor: string;
  } {
    let secondTitleColor: string = 'black';
    let firstConditionColor: string = 'black';
    let secondConditionColor: string = 'black';
    let thirdConditionColor: string = 'black';
    let fourthConditionColor: string = 'black';
    let fifthConditionColor: string = 'black';
    let sixthConditionColor: string = 'black';
    let seventhConditionColor: string = 'black';

    if (archer !== undefined) {
      secondTitleColor =
        archer.validationErrorCase === 1 || archer.isOpen === false
          ? 'red'
          : archer.isOpen
          ? 'green'
          : 'black';

      firstConditionColor =
        archer.validationErrorCase === 2 ||
        (archer.hasAcceptances === false &&
          archer.hasRemediationPlans === false)
          ? 'red'
          : archer.hasValidRemediationPlans
          ? 'green'
          : 'black';

      secondConditionColor =
        archer.validationErrorCase === 0 || archer.hasValidDueDate === false
          ? 'red'
          : archer.hasValidDueDate
          ? 'green'
          : 'black';

      thirdConditionColor =
        archer.validationErrorCase === 4 ||
        (archer.hasAcceptances === false &&
          archer.hasRemediationPlans &&
          archer.hasValidRemediationPlanStatus === false)
          ? 'red'
          : archer.hasValidRemediationPlans ||
            archer.hasValidRemediationPlanStatus
          ? 'green'
          : 'black';

      fourthConditionColor = fifthConditionColor =
        archer.validationErrorCase === 5
          ? 'red'
          : archer.hasValidRemediationPlans
          ? 'green'
          : 'black';

      sixthConditionColor =
        archer.validationErrorCase === 2 ||
        (archer.hasAcceptances === false &&
          archer.hasRemediationPlans === false)
          ? 'red'
          : archer.hasValidAcceptances
          ? 'green'
          : 'black';

      seventhConditionColor =
        archer.validationErrorCase === 3 ||
        (archer.hasAcceptances && archer.hasValidAcceptanceStatus === false)
          ? 'red'
          : archer.hasValidAcceptanceStatus
          ? 'green'
          : 'black';
    }

    return {
      secondTitleColor,
      firstConditionColor,
      secondConditionColor,
      thirdConditionColor,
      fourthConditionColor,
      fifthConditionColor,
      sixthConditionColor,
      seventhConditionColor,
    };
  }
}
